import React from 'react';

import { get } from 'lodash';
import axios from 'axios';
import { toast } from 'react-toastify';

import { API_HOST } from '../../consts';
import { Form } from 'informed';
import { withRouter } from 'react-router-dom';
import FormContainer from '../../containers/Form';
import InputSelect from '../../components/inputs/InputSelect';
import LabelView from '../../components/LabelView';
import InputCheckbox from '../../components/inputs/InputCheckbox';
import { InputText } from '../../components/inputs';
import InputNumber from '../../components/inputs/InputNumber';

class IntegracaoTOTVS extends React.Component {
  state = {
    avaliacao: undefined,
    avaliacoes: [],
    codigo_etapas: [],
    periodo_letivo_tp: [],
    periodoLetivoAtualTp: null,
    data_importacao_dado: [],
    dataImportacaoDadoAtual: null,
    cursos: [],
    cursoAtual: [],
    coligadaAtual: [],
    filialAtual: [],
    disciplinas: [],
    turma_disciplina: [],
    turma: [],
    turmaDisciplinaAtual: null,
    cursosAtual: null,
    disciplinaAtual: null,
    turmaAtual: null,
    integracaoPayload: null,
    periodo_letivo: null,
    provaIntegradora: true,
    testeProgresso: false,
    coligadas: [],
    filiais: [],
    coligada: null,
    filial: null,
    cod_curso: null,
    cod_etapa: null,
    periodo_turma: null,
    metadata: []
  };

  metadataModels = ['integracao_totvs'];

  mapMetadata(metadata) {
    const mapped = {};
    metadata &&
      metadata
        .filter((d) => d.is_active === true)
        .forEach((m) => {
          mapped[`${m.model}.${m.name}`] = m.is_active;
        });
    return mapped;
  }

  shouldDisplayDefault(field) {
    const { metadata } = this.state;
    return get(metadata, field);
  }

  fetchMetadata() {
    this.setState({ fetchingMetadata: true });
    return axios
      .get(`${API_HOST}/params/param?model=${this.metadataModels.join('|')}`)
      .then((response) => {
        this.setState({
          metadata: this.mapMetadata(response.data),
          fetchingMetadata: false
        });
      });
  }

  fetchColigada = () => {
    axios
      .get(`${API_HOST}/avaliacoes/avaliacao/get_coligada_from_totvs`)
      .then((res) => {
        this.setState({
          coligadas: res.data
        });
      })
      .catch((err) => {
        toast.error('Ocorreu um erro, tente novamente.');
        console.error(err);
      });
  };

  fetchFilial = (coligada) => {
    const { coligadaAtual } = this.state;

    if (
      coligadaAtual &&
      get(coligadaAtual, 'descricao') !== get(coligada, 'descricao')
    ) {
      this.formApi.setValue('avaliacoes', null);
      this.formApi.setValue('filial', null);
    }
    if (coligada) {
      axios
        .get(
          `${API_HOST}/avaliacoes/avaliacao/get_filial_from_totvs?coligada=${coligada.descricao}`
        )
        .then((res) => {
          this.setState({
            filiais: res.data,
            coligadaAtual: coligada
          });
        })
        .catch((err) => {
          toast.error('Ocorreu um erro, tente novamente.');
          console.error(err);
        });
    }
  };

  getFilialAtualParam = () => {
    const { filialAtual } = this.state;
    return get(filialAtual, 'descricao');
  };

  fetchCursos = (filial) => {
    const filialParam = get(filial, 'descricao');
    if (!filialParam) {
      this.setState({ cursos: [] });
      return;
    }

    axios
      .get(
        `${API_HOST}/avaliacoes/avaliacao/get_cursos_from_totvs_distinct_period?filial=${filialParam}`
      )
      .then((res) => {
        this.setState({ cursos: res.data });
      })
      .catch((err) => {
        toast.error('Ocorreu um erro');
        console.error(err);
      });
  };

  fetchCursosTP = (coligada) => {
    const { coligadaAtual } = this.state;

    if (
      coligadaAtual &&
      get(coligadaAtual, 'descricao') !== get(coligada, 'descricao')
    ) {
      this.formApi.setValue('avaliacoes', null);
      this.formApi.setValue('curso', null);
    }
    if (coligada) {
      axios
        .get(
          `${API_HOST}/avaliacoes/avaliacao/get_cursos_from_totvs_distinct_period?coligada=${coligada.descricao}`
        )
        .then((res) => {
          this.setState({ cursos: res.data, coligadaAtual: coligada });
        })
        .catch((err) => {
          toast.error('Ocorreu um erro');
          console.error(err);
        });
    }
  };

  fetchFiliais = () => {
    axios
      .get(`${API_HOST}/avaliacoes/avaliacao/get_filial_from_totvs`)
      .then((res) => {
        this.setState({
          filiais: res.data
        });
      })
      .catch((err) => {
        toast.error('Ocorreu um erro, tente novamente.');
        console.error(err);
      });
  };

  handleFilialChange = (filialAtual) => {
    this.formApi.setValue('curso', null);
    this.formApi.setValue('disciplina', null);
    this.formApi.setValue('turma', null);
    this.formApi.setValue('turma_disciplina', null);
    this.formApi.setValue('avaliacoes', null);

    this.setState(
      {
        filialAtual,
        cursoAtual: null,
        disciplinaAtual: null,
        turmaAtual: null,
        turmaDisciplinaAtual: null,
        avaliacaoAtual: null,
        disciplinas: [],
        turma: [],
        turma_disciplina: [],
        avaliacoes: []
      },
      () => this.fetchCursos(filialAtual)
    );
  };

  fetchAvaliacao = () => {
    const { match } = this.props;

    axios
      .get(`${API_HOST}/avaliacoes/avaliacao/${match.params.id}`)
      .then((res) => {
        this.setState({ avaliacao: res.data }, this.setInitialValues);
      })
      .catch((err) => {
        toast.error('Ocorreu um erro');
        console.error(err);
      });
  };

  fetchDisciplinas = (curso) => {
    const { cursoAtual } = this.state;
    const filial = this.getFilialAtualParam();



    if (
      cursoAtual &&
      get(cursoAtual, 'descricao') !== get(curso, 'descricao')
    ) {
      this.formApi.setValue('avaliacoes', null);
      this.formApi.setValue('disciplina', null);
    }
    if (curso) {
      axios
        .get(
          `${API_HOST}/avaliacoes/avaliacao/get_disciplinas_from_totvs?curso=${curso.descricao}&filial=${filial}`
        )
        .then((res) => {
          this.setState({ disciplinas: res.data, cursoAtual: curso });
        })
        .catch((err) => {
          toast.error('Ocorreu um erro, tente novamente.');
          console.error(err);
        });
    }
  };

  fetchPeriodo = (idDisciplina) => {
    const { cursoAtual, disciplinaAtual } = this.state;
    const filial = this.getFilialAtualParam();



    if (
      disciplinaAtual &&
      get(disciplinaAtual, 'descricao') !== get(idDisciplina, 'descricao')
    ) {
      this.formApi.setValue('avaliacoes', null);
      this.formApi.setValue('turma', null);
    }

    if (idDisciplina && cursoAtual) {
      axios
        .get(
          `${API_HOST}/avaliacoes/avaliacao/get_periodo_from_totvs?curso=${cursoAtual.descricao}&id_disciplina=${idDisciplina.descricao}&filial=${filial}`
        )
        .then((res) => {
          this.setState({
            turma: res.data,
            disciplinaAtual: idDisciplina
          });
        })
        .catch((err) => {
          toast.error('Ocorreu um erro, tente novamente.');
          console.error(err);
        });
    }
  };

  fetchTurmaDisciplina = (periodo) => {
    const { cursoAtual, turmaAtual, disciplinaAtual } = this.state;
    const filial = this.getFilialAtualParam();

    if (
      turmaAtual &&
      get(turmaAtual, 'descricao') !== get(periodo, 'descricao')
    ) {
      this.formApi.setValue('avaliacoes', null);
      this.formApi.setValue('turma_disciplina', null);
    }

    if (periodo && cursoAtual) {
      const turmaIds = Array.isArray(periodo)
        ? periodo.map((t) => t.descricao).join(',')
        : periodo.descricao;

      axios
        .get(
          `${API_HOST}/avaliacoes/avaliacao/get_turma_disciplina_from_totvs?curso=${cursoAtual.descricao}&id_turma=${turmaIds}&filial=${filial}&id_disciplina=${disciplinaAtual.descricao}`
        )
        .then((res) => {
          this.setState({
            turma_disciplina: res.data,
            turmaAtual: periodo
          });
        })
        .catch((err) => {
          toast.error('Ocorreu um erro, tente novamente.');
          console.error(err);
        });
    }
  };

  fetchAvaliacoesPeriodo = (turmaPeriodo) => {
    const { cursoAtual, turmaAtual, disciplinaAtual } = this.state;
    const filial = this.getFilialAtualParam();



    if (
      turmaAtual &&
      get(turmaAtual, 'descricao') !== get(turmaPeriodo, 'descricao')
    ) {
      this.formApi.setValue('avaliacoes', null);
    }

    if (turmaPeriodo && cursoAtual && disciplinaAtual) {
      const turmaIds = Array.isArray(turmaPeriodo)
        ? turmaPeriodo.map((t) => t.id).join(',')
        : turmaPeriodo.id;

      axios
        .get(
          `${API_HOST}/avaliacoes/avaliacao/get_avaliacoes_from_totvs?curso=${cursoAtual.descricao}&id_disciplina=${disciplinaAtual.descricao}&turma_id=${turmaIds}&filial=${filial}`
        )
        .then((res) => {
          this.setState({
            avaliacoes: res.data,
            turmaAtual: turmaPeriodo
          });
        })
        .catch((err) => {
          toast.error('Ocorreu um erro, tente novamente.');
          console.error(err);
        });
    }
  };

  fetchPeriodoLetivo = (codigo) => {
    const { codigoEtapaAtual, dataImportacaoDadoAtual } = this.state;

    if (
      codigoEtapaAtual &&
      get(codigoEtapaAtual, 'descricao') !== get(codigo, 'descricao')
    ) {
      this.formApi.setValue('periodo_letivo_tp', null);
      this.formApi.setValue('codigo_etapas', null);
    }
    if (codigo) {
      axios
        .get(
          `${API_HOST}/avaliacoes/avaliacao/get_periodo_letivo_from_totvs?codigo=${codigo.id}&data_importacao_dado=${dataImportacaoDadoAtual &&
          dataImportacaoDadoAtual.map((t) => t.label).join(',')}`
        )
        .then((res) => {
          this.setState({
            periodo_letivo_tp: res.data,
            codigoEtapaAtual: codigo
          });
        })
        .catch((err) => {
          toast.error('Ocorreu um erro, tente novamente.');
          console.error(err);
        });
    }
  };

  fetchDataImportacao = () => {
    axios
      .get(
        `${API_HOST}/avaliacoes/avaliacao/get_data_importacao_from_totvs`
      )
      .then((res) => {
        this.setState({
          data_importacao_dado: res.data,
        });
      })
      .catch((err) => {
        toast.error('Ocorreu um erro, tente novamente.');
        console.error(err);
      });

  };

  fetchAvaliacoes = (turmaDisciplina) => {
    const { cursoAtual, turmaDisciplinaAtual, disciplinaAtual } = this.state;
    const filial = this.getFilialAtualParam();

    if (
      turmaDisciplinaAtual &&
      get(turmaDisciplinaAtual, 'descricao') !==
      get(turmaDisciplina, 'descricao')
    ) {
      this.formApi.setValue('avaliacoes', null);
    }

    if (turmaDisciplina && cursoAtual && disciplinaAtual) {
      axios
        .get(
          `${API_HOST}/avaliacoes/avaliacao/get_avaliacoes_from_totvs?curso=${cursoAtual.descricao}&id_disciplina=${disciplinaAtual.descricao}&turma_disciplina_id=${turmaDisciplina.id}&filial=${filial}`
        )
        .then((res) => {
          this.setState({
            avaliacoes: res.data,
            turmaDisciplinaAtual: turmaDisciplina
          });
        })
        .catch((err) => {
          toast.error('Ocorreu um erro, tente novamente.');
          console.error(err);
        });
    }
  };

  fetchAvaliacoesTP = (curso) => {
    const { cursoAtual } = this.state;

    if (
      cursoAtual &&
      get(cursoAtual, 'descricao') !== get(curso, 'descricao')
    ) {
      this.formApi.setValue('avaliacoes', null);
    }
    if (curso) {
      axios
        .get(
          `${API_HOST}/avaliacoes/avaliacao/get_avaliacoes_from_totvs?curso=${curso.descricao}`
        )
        .then((res) => {
          this.setState({
            avaliacoes: res.data,
            cursoAtual: curso
          });
        })
        .catch((err) => {
          toast.error('Ocorreu um erro, tente novamente.');
          console.error(err);
        });
    }
  };

  fetchCodEtapaTP = (avaliacao) => {
    const { AvaliacaoAtual } = this.state;

    if (
      AvaliacaoAtual &&
      get(AvaliacaoAtual, 'descricao') !== get(avaliacao, 'descricao')
    ) {
      this.formApi.setValue('codigo_etapas', null);
    }
    if (avaliacao) {
      axios
        .get(
          `${API_HOST}/avaliacoes/avaliacao/get_cod_etapa_from_totvs?avaliacao=${avaliacao.id}`
        )
        .then((res) => {
          this.setState({
            codigo_etapas: res.data,
            avaliacaoAtual: avaliacao
          });
        })
        .catch((err) => {
          toast.error('Ocorreu um erro, tente novamente.');
          console.error(err);
        });
    }
  };

  setInitialValues = () => {
    const initialValues = this.formatInitialValues();
    this.formApi.setValues(initialValues);
  };

  componentDidMount() {
    Promise.all([
      this.fetchMetadata(),
      this.fetchAvaliacao(),
      this.fetchColigada(),
      this.fetchFiliais(),
      this.fetchDataImportacao()
    ]);
  }

  formatIntegracaoPayload = () => {
    const {
      cursoAtual,
      disciplinaAtual,
      turmaDisciplinaAtual,
      avaliacaoAtual,
      provaIntegradora,
      periodo_letivo,
      periodoLetivoAtualTp,
      coligada,
      filial,
      cod_curso,
      cod_etapa,
      periodo_turma,
      testeProgresso,
      coligadaAtual,
      codigoEtapaAtual,
      turmaAtual,
      dataImportacaoDadoAtual
    } = this.state;
    const filialAtual = this.getFilialAtualParam();

    return provaIntegradora
      ? JSON.stringify({
        periodo_letivo: periodo_letivo,
        periodo_turma: periodo_turma,
        coligada: coligada,
        filial: filial,
        cod_curso: cod_curso,
        cod_etapa: cod_etapa
      })
      : testeProgresso
        ? JSON.stringify({
          curso: cursoAtual.descricao,
          cod_etapa: codigoEtapaAtual.descricao,
          // disciplina: disciplinaAtual.label,
          // id_disciplina: disciplinaAtual.descricao,
          coligada: coligadaAtual.descricao,
          avaliacao: avaliacaoAtual.descricao,
          periodo_letivo_tp:
            periodoLetivoAtualTp &&
            periodoLetivoAtualTp.map((t) => t.id).join(','),
          data_importacao_dado: dataImportacaoDadoAtual &&
            dataImportacaoDadoAtual.map((t) => t.label).join(',')
        })
        : JSON.stringify({
          filial: filialAtual,
          curso: cursoAtual.descricao,
          disciplina: disciplinaAtual.label,
          id_disciplina: disciplinaAtual.descricao,
          turma_id: turmaAtual && turmaAtual.map((t) => t.id).join(','),
          turma_disciplina_id: turmaDisciplinaAtual && turmaDisciplinaAtual.id,
          turma_disciplina_ds:
            turmaDisciplinaAtual && turmaDisciplinaAtual.descricao,
          avaliacao: avaliacaoAtual.descricao,
          avaliacaoId: avaliacaoAtual.id
        });
  };

  handleUpdateAvaliacao = () => {
    const { match } = this.props;
    const { provaIntegradora, testeProgresso } = this.state;
    const integracaoPayload = this.formatIntegracaoPayload();
    axios
      .patch(
        `${API_HOST}/avaliacoes/avaliacao/${match.params.id}/update_integracao_field`,
        {
          integracaoPayload,
          provaIntegradora,
          testeProgresso
        }
      )
      .then((res) => {
        const { history } = this.props;
        if (res.status === 200) {
          history.push('/instrumentos-cognitivos');
          toast.success('Dados enviados para processamento!');
        }
      })
      .catch((err) => {
        const status = get(err, 'response.status');
        const errorMessage = get(err, 'response.data');
        if (status === 404) {
          toast.error(
            'Para finalizar, é necessário preencher todos os campos.'
          );
        } else {
          toast.error(errorMessage);
        }
        console.error(err);
      });
  };

  formatInitialValues = () => {
    const { avaliacao } = this.state;

    const prova_integradora = avaliacao.prova_integradora;
    const teste_progresso = avaliacao.teste_progresso;

    const rawIntegracaoTotvs = JSON.parse(
      get(avaliacao, 'integracao_totvs', '{}')
    );

    const curso = get(rawIntegracaoTotvs, 'curso')
      ? {
        id: get(rawIntegracaoTotvs, 'curso'),
        value: get(rawIntegracaoTotvs, 'curso'),
        label: get(rawIntegracaoTotvs, 'curso'),
        descricao: get(rawIntegracaoTotvs, 'curso')
      }
      : undefined;

    const disciplina = get(rawIntegracaoTotvs, 'disciplina')
      ? {
        id: get(rawIntegracaoTotvs, 'disciplina'),
        idDisciplina: get(rawIntegracaoTotvs, 'id_disciplina'),
        value: get(rawIntegracaoTotvs, 'disciplina'),
        label: get(rawIntegracaoTotvs, 'disciplina'),
        descricao: get(rawIntegracaoTotvs, 'id_disciplina')
      }
      : undefined;

    const avaliacoes = get(rawIntegracaoTotvs, 'avaliacao')
      ? {
        id: get(rawIntegracaoTotvs, 'avaliacaoId'),
        value: get(rawIntegracaoTotvs, 'avaliacao'),
        label: get(rawIntegracaoTotvs, 'avaliacao'),
        descricao: get(rawIntegracaoTotvs, 'avaliacao')
      }
      : undefined;
    const turma_disciplina = get(rawIntegracaoTotvs, 'turma_disciplina_id')
      ? {
        id: get(rawIntegracaoTotvs, 'turma_disciplina_id'),
        idTurmaDisciplina: get(rawIntegracaoTotvs, 'turma_disciplina_id'),
        value: get(rawIntegracaoTotvs, 'turma_disciplina_id'),
        label: get(rawIntegracaoTotvs, 'turma_disciplina_ds'),
        descricao: get(rawIntegracaoTotvs, 'turma_disciplina_ds')
      }
      : undefined;

    const turma = get(rawIntegracaoTotvs, 'turma_id')
      ? get(rawIntegracaoTotvs, 'turma_id')
        .split(',')
        .map((id) => ({
          id: id.trim(),
          value: id.trim(),
          label: id.trim(),
          descricao: id.trim()
        }))
      : undefined;

    const coligadas = get(rawIntegracaoTotvs, 'coligada')
      ? {
        id: get(rawIntegracaoTotvs, 'coligada'),
        value: get(rawIntegracaoTotvs, 'coligada'),
        label: get(rawIntegracaoTotvs, 'coligada'),
        descricao: get(rawIntegracaoTotvs, 'coligada')
      }
      : undefined;

    const codigo_etapas = get(rawIntegracaoTotvs, 'cod_etapa')
      ? {
        id: get(rawIntegracaoTotvs, 'cod_etapa'),
        value: get(rawIntegracaoTotvs, 'cod_etapa'),
        label: get(rawIntegracaoTotvs, 'cod_etapa'),
        descricao: get(rawIntegracaoTotvs, 'cod_etapa')
      }
      : undefined;

    const periodo_letivo_tp = get(rawIntegracaoTotvs, 'periodo_letivo_tp')
      ? get(rawIntegracaoTotvs, 'periodo_letivo_tp')
        .split(',')
        .map((id) => ({
          id: id.trim(),
          value: id.trim(),
          label: id.trim(),
          descricao: id.trim()
        }))
      : undefined;

    const data_importacao_dado = get(rawIntegracaoTotvs, 'data_importacao_dado')
      ? get(rawIntegracaoTotvs, 'data_importacao_dado')
        .split(',')
        .map((id) => ({
          id: id.trim(),
          value: id.trim(),
          label: id.trim(),
          descricao: id.trim()
        }))
      : undefined;


    // Dados Prova Integadora
    const cod_curso = get(rawIntegracaoTotvs, 'cod_curso');
    const cod_etapa = get(rawIntegracaoTotvs, 'cod_etapa');
    const periodo_turma = get(rawIntegracaoTotvs, 'periodo_turma');
    const coligada = get(rawIntegracaoTotvs, 'coligada');
    const periodo_letivo = get(rawIntegracaoTotvs, 'periodo_letivo');

    const rawFilial = get(rawIntegracaoTotvs, 'filial');
    const filial = prova_integradora ? rawFilial : undefined;
    const filialAtual = !prova_integradora && !teste_progresso && rawFilial
      ? {
        id: rawFilial,
        value: rawFilial,
        label: rawFilial,
        descricao: rawFilial
      }
      : undefined;

    this.setState(
      {
        provaIntegradora: prova_integradora,
        testeProgresso: teste_progresso,
        cursoAtual: curso,
        coligadaAtual: coligadas,
        filialAtual: filialAtual,
        turmaAtual: turma,
        codigoEtapaAtual: codigo_etapas,
        disciplinaAtual: disciplina,
        turmaDisciplinaAtual: turma_disciplina,
        avaliacaoAtual: avaliacoes,
        periodo_letivo: periodo_letivo,
        coligada: coligada,
        filial: filial,
        cod_curso: cod_curso,
        cod_etapa: cod_etapa,
        periodo_turma: periodo_turma,
        periodo_letivo_tp: periodo_letivo_tp,
        periodoLetivoAtualTp: periodo_letivo_tp,
        data_importacao_dado: data_importacao_dado,
        dataImportacaoDadoAtual: data_importacao_dado
      },
      () => {
        if (filialAtual) {
          this.fetchCursos(filialAtual);
        }
        if (curso) {
          this.fetchDisciplinas(curso);
        }
        if (disciplina && this.state.testeProgresso) {
          this.fetchPeriodo(disciplina);
          this.fetchAvaliacoesTP(disciplina);
        }
        if (turma_disciplina) {
          this.fetchAvaliacoes(turma_disciplina);
        }
        if (turma) {
          this.fetchTurmaDisciplina(turma);
          this.fetchAvaliacoesPeriodo(turma);
        }
      }
    );

    return {
      teste_progresso,
      prova_integradora,
      periodo_letivo,
      turma,
      coligada,
      coligadas,
      filial,
      filial_integracao: filialAtual,
      cod_curso,
      cod_etapa,
      periodo_turma,
      turma_disciplina,
      curso,
      disciplina,
      avaliacoes,
      codigo_etapas,
      periodo_letivo_tp,
      data_importacao_dado
    };
  };

  render() {
    const {
      avaliacoes,
      cursos,
      disciplinas,
      avaliacao,
      provaIntegradora,
      turma_disciplina,
      coligada,
      filial,
      periodo_letivo,
      cod_curso,
      cod_etapa,
      periodo_turma,
      testeProgresso,
      coligadas,
      filiais,
      filialAtual,
      turma,
      codigo_etapas,
      periodo_letivo_tp,
      data_importacao_dado
    } = this.state;
    const filialSelecionada = get(filialAtual, 'descricao');

    return (
      <Form
        getApi={(formApi) => {
          this.formApi = formApi;
        }}
      >
        <FormContainer
          title="Integração TOTVS"
          previous="itens"
          onClick={this.handleUpdateAvaliacao}
          last="instrumentos-cognitivos"
        >
          <div className="row">
            <LabelView
              col="col-sm-6"
              title="Avaliação"
              text={get(avaliacao, 'nome')}
            />
            <LabelView
              col="col-sm-6"
              title="Número de Itens"
              text={get(avaliacao, 'itens')}
            />
          </div>
          <hr />
          <div className="row">
            {this.shouldDisplayDefault(
              'integracao_totvs.prova_integradora'
            ) && (
                <InputCheckbox
                  col="col-md-5 col-sm-12"
                  label="Prova integradora"
                  field="prova_integradora"
                  onChange={(event) =>
                    this.setState({ provaIntegradora: event.target.checked })
                  }
                />
              )}
            {this.shouldDisplayDefault('integracao_totvs.teste_progresso') && (
              <InputCheckbox
                col="col-md-5 col-sm-12"
                label="Teste de progresso"
                field="teste_progresso"
                onChange={(event) =>
                  this.setState({ testeProgresso: event.target.checked })
                }
              />
            )}
          </div>
          {provaIntegradora ? (
            <div className="row" style={{ marginBottom: '1.5rem' }}>
              <InputNumber
                col="col-sm-6"
                label="Coligada"
                field="coligada"
                value={coligada}
                onChange={(event) => {
                  this.setState({ coligada: event });
                }}
              />
              <InputNumber
                col="col-sm-6"
                label="Filial"
                field="filial"
                value={filial}
                onChange={(event) => {
                  this.setState({ filial: event });
                }}
              />
              <InputText
                col="col-sm-6"
                label="Período Letivo"
                field="periodo_letivo"
                value={periodo_letivo}
                onChange={(event) => {
                  this.setState({ periodo_letivo: event });
                }}
              />
              <InputText
                col="col-sm-6"
                label="Período Turma"
                field="periodo_turma"
                value={periodo_turma}
                onChange={(event) => {
                  this.setState({ periodo_turma: event });
                }}
              />
              <InputText
                col="col-sm-12"
                label="Curso"
                field="cod_curso"
                value={cod_curso}
                onChange={(event) => this.setState({ cod_curso: event })}
              />
              <InputText
                col="col-sm-12"
                label="Etapa"
                field="cod_etapa"
                value={cod_etapa}
                onChange={(event) => this.setState({ cod_etapa: event })}
              />
            </div>
          ) : testeProgresso ? (
            <div className="row" style={{ marginBottom: '1.5rem' }}>
              <InputSelect
                label="Data da importação do dado"
                col="col-md-4"
                field="data_importacao_dado"
                onChange={(dataImportacaoDadoAtual) =>
                  this.setState({ dataImportacaoDadoAtual })
                }
                options={data_importacao_dado}
                multi
              />
              <InputSelect
                label="Coligada"
                col="col-md-4"
                field="coligadas"
                onChange={this.fetchCursosTP}
                options={coligadas}
              />
              <InputSelect
                label="Curso"
                col="col-md-4"
                field="curso"
                onChange={this.fetchAvaliacoesTP}
                options={cursos}
              />
              <InputSelect
                label="Avaliação"
                col="col-md-4"
                field="avaliacoes"
                onChange={this.fetchCodEtapaTP}
                options={avaliacoes}
              />
              <InputSelect
                label="Código da Etapa"
                col="col-md-4"
                field="codigo_etapas"
                onChange={this.fetchPeriodoLetivo}
                options={codigo_etapas}
              />
              <InputSelect
                label="Período Letivo"
                col="col-md-4"
                field="periodo_letivo_tp"
                onChange={(periodoLetivoAtualTp) =>
                  this.setState({ periodoLetivoAtualTp })
                }
                options={periodo_letivo_tp}
                multi
              />
            </div>
          ) : (
            <div className="row" style={{ marginBottom: '1.5rem' }}>
              <InputSelect
                label="Filial"
                col="col-md-4"
                field="filial_integracao"
                onChange={this.handleFilialChange}
                options={filiais}
              />
              <InputSelect
                label="Curso"
                col="col-md-4"
                field="curso"
                onChange={this.fetchDisciplinas}
                options={cursos}
                disabled={!filialSelecionada}
              />
              <InputSelect
                label="Disciplina"
                col="col-md-4"
                field="disciplina"
                onChange={this.fetchPeriodo}
                options={disciplinas}
                disabled={!filialSelecionada}
              />
              <InputSelect
                label="Período"
                col="col-md-4"
                field="turma"
                onChange={(e) => {
                  this.fetchTurmaDisciplina(e);
                  this.fetchAvaliacoesPeriodo(e);
                }}
                options={turma}
                disabled={!filialSelecionada}
                multi
              />
              <InputSelect
                label="Turma Disciplina"
                col="col-md-4"
                field="turma_disciplina"
                onChange={this.fetchAvaliacoes}
                options={turma_disciplina}
                disabled={!filialSelecionada}
              />
              <InputSelect
                label="Avaliação"
                col="col-md-4"
                field="avaliacoes"
                onChange={(avaliacaoAtual) => this.setState({ avaliacaoAtual })}
                options={avaliacoes}
                disabled={!filialSelecionada}
              />
            </div>
          )}
        </FormContainer>
      </Form>
    );
  }
}

export default withRouter(IntegracaoTOTVS);
